import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.y3p_1 = new (CouplingImages())('overlayPng', 'graphqlSvg', 'logoSvg', 'noPartyImagePath', 'noPlayerImagePath', 'frodo', 'samwise', 'grayson', 'wayne', 'rosie', 'wendy', 'robPng', 'autumnPng');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CouplingImagesClass;
function CouplingImages() {
  if (CouplingImagesClass === VOID) {
    class $ {
      constructor(overlayPng, graphqlSvg, logoSvg, noPartyImagePath, noPlayerImagePath, frodo, samwise, grayson, wayne, rosie, wendy, robPng, autumnPng) {
        Companion_getInstance();
        this.l3p_1 = overlayPng;
        this.m3p_1 = graphqlSvg;
        this.n3p_1 = logoSvg;
        this.o3p_1 = noPartyImagePath;
        this.p3p_1 = noPlayerImagePath;
        this.q3p_1 = frodo;
        this.r3p_1 = samwise;
        this.s3p_1 = grayson;
        this.t3p_1 = wayne;
        this.u3p_1 = rosie;
        this.v3p_1 = wendy;
        this.w3p_1 = robPng;
        this.x3p_1 = autumnPng;
      }
      toString() {
        return 'CouplingImages(overlayPng=' + this.l3p_1 + ', graphqlSvg=' + this.m3p_1 + ', logoSvg=' + this.n3p_1 + ', noPartyImagePath=' + this.o3p_1 + ', noPlayerImagePath=' + this.p3p_1 + ', frodo=' + this.q3p_1 + ', samwise=' + this.r3p_1 + ', grayson=' + this.s3p_1 + ', wayne=' + this.t3p_1 + ', rosie=' + this.u3p_1 + ', wendy=' + this.v3p_1 + ', robPng=' + this.w3p_1 + ', autumnPng=' + this.x3p_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.l3p_1);
        result = imul(result, 31) + getStringHashCode(this.m3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x3p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CouplingImages()))
          return false;
        if (!(this.l3p_1 === other.l3p_1))
          return false;
        if (!(this.m3p_1 === other.m3p_1))
          return false;
        if (!(this.n3p_1 === other.n3p_1))
          return false;
        if (!(this.o3p_1 === other.o3p_1))
          return false;
        if (!(this.p3p_1 === other.p3p_1))
          return false;
        if (!(this.q3p_1 === other.q3p_1))
          return false;
        if (!(this.r3p_1 === other.r3p_1))
          return false;
        if (!(this.s3p_1 === other.s3p_1))
          return false;
        if (!(this.t3p_1 === other.t3p_1))
          return false;
        if (!(this.u3p_1 === other.u3p_1))
          return false;
        if (!(this.v3p_1 === other.v3p_1))
          return false;
        if (!(this.w3p_1 === other.w3p_1))
          return false;
        if (!(this.x3p_1 === other.x3p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CouplingImages');
    CouplingImagesClass = $;
  }
  return CouplingImagesClass;
}
//region block: exports
export {
  CouplingImages as CouplingImagesci5yi3b0zpw0,
  Companion_getInstance as Companion_getInstanceer3bzpd0z8sw,
};
//endregion

//# sourceMappingURL=CouplingImages.mjs.map
